<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增问题
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
	  
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status===1?'禁用':'启用'"
            :alert-title="record.data.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <question-modal
      ref="formRef"
      :question-visible="questionVisible"
      :show-error-msg="showErrorMsg"
      :show-answer-msg="showAnswerMsg"
      :form-data="formData"
      :title="title"
      @onCancel="onCancel"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </question-modal>
  </div>
</template>
<script>
const uuidv1 = require('uuid/v1');
import { questionColumns } from '../data/index';
import QuestionModal from '../modal/questionModal.vue';
export default {
  components: { QuestionModal },
  data() {
    return {
      selectData: [],
      columns: questionColumns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      questionVisible: false,
      title: '',
      questionId: undefined,
      paperId: undefined,
      btnIsLoading: false,
      showErrorMsg: false,
      showAnswerMsg: false,
      paperData: [{
        key: 1, name: '单选',
      },
      {
        key: 2, name: '多选',
      },
      ],
      formData: {
        dynamicData: [{uid: uuidv1(), options: '', answers: ''}],
      }
      ,
    };
  },
  mounted() {
    this.paperId=this.$route.query.id;
    // 获取表格数据
    this.getTableData({ paper_id: this.paperId, page: this.current, pageSize: this.pageSize });
  },
  methods: {

    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/paper/paperQuestionList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            paper_title: item.paper_title,
            paper_type: this.paperData.find((option)=>option.key===item.paper_type).name,
            score: item.score,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 编辑或新增
    editAndAdd(record) {
      console.log('editAndAdd -> record', record);
      this.questionVisible = true;

      if (!record.id) {
        // 新增
        this.title = '新增问题';
        this.questionId=undefined;
        this.$refs.formRef.initData();
        this.$nextTick(() => {
          this.$refs.formRef.form.resetFields();
        });
      } else {
        // 编辑
        this.questionId = record.id;
        this.title = '编辑问题';
        let list= record.data.option_list.map((item)=>{return {uid: uuidv1(), options: item.option_title, answers: item.is_answer};});
        this.$refs.formRef.updateData(list);
        let data = {
          paper_title: record.paper_title,
          paper_type: record.data.paper_type,
          score: record.score,
          err_msg: record.data.err_msg,
        };
        list.forEach((item)=>{
          data[item.uid]={options: item.options, answers: item.answers};
        });
        console.log('data', data);
        this.formData=data;
        this.$nextTick(() => {
          console.log('editAndAdd -> this.formData', this.formData);
          this.$refs.formRef.form.setFieldsValue(this.formData);

        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.form.validateFields(
        async(err, values) => {
          console.log('onSubmits2222 -> values', values);
          if (!err) {
            let options=[];
            let answers=[];
            let temp=Object.values(values);
            for(let i=0;i<temp.length;i++){
              if(typeof temp[i] ==='object'){
                if(temp[i].options){
                  options.push(temp[i].options);
                }
                if(temp[i].answers||temp[i].answers===0){
                  answers.push(temp[i].answers);
                }
                if(!temp[i].options||(!temp[i].answers&&temp[i].answers!==0)){
                  this.$message.warning('问题选项请填写完整！');
                  return;
                }
              }
            }

            values.options=options;
            values.answers=answers;
            // 单选检验
            if(values.paper_type===1){
              if(values.answers.filter((item)=>item===1).length!==1){
                this.$message.warning('单选题答案有且只有一个！');
                return;
              }
            }
            // 多选检验
            if(values.paper_type===2){
              if(values.answers.filter((item)=>item===1).length<2){
                this.$message.warning('多选题答案2个以上！');
                return;
              }
            }
            console.log(3333);
            console.log('onSubmit -> values', values);
            this.btnIsLoading=true;
            let result = await this.$http.post('/paper/paperQuestionUpdate', {
              ...values,
              paper_id: this.paperId,
              id: this.questionId,
            });
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.questionVisible = false;
              this.getTableData({ paper_id: this.paperId, page: this.current, pageSize: this.pageSize });
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.questionVisible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/paper/paperQuestionSet', {id: record.id, status: record.data.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ paper_id: this.paperId, page: this.current, pageSize: this.pageSize });
      }
    },
    // 删除
    async onDelete(record) {
      let result = await this.$http.post('/paper/paperQuestionDel', {
        id: record.id,
      });
      if (result.data.status === 1) {
        this.$message.success(result.data.msg);
        this.getTableData({ paper_id: this.paperId, page: this.current, pageSize: this.pageSize });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({ paper_id: this.paperId, page: this.current, pageSize: this.pageSize });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
</style>
